import { Component, OnInit, Input } from '@angular/core';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { BoxInfoTruckService } from '../box-info-truck/box-info-truck.service';
import { MainHeaderTruckService } from './main-header-truck.service';
import { ControlStatusService, State } from '../shared/control-status.service';
import { GraphicService } from '../shared/graphic.service';
import { Util } from '../shared/Util';
import { isNullOrUndefined } from 'is-what';
import { NgIf, DatePipe } from '@angular/common';

@Component({
    selector: 'main-header-truck',
    templateUrl: './main-header-truck.component.html',
    styleUrls: ['./main-header-truck.component.css'],
    standalone: true,
    imports: [NgIf, DatePipe]
})
export class MainHeaderTruckComponent implements OnInit {

  @Input() roteiro;
  dataUltimaInformacao: Date;
  numeroRoteiroBusca: number;
  canSeeConfig: boolean = false;


  constructor(
    public boxListTruckService: BoxListTruckService,
    private boxInfoAlertService: BoxInfoAlertService,
    private boxInfoRouterService: BoxInfoRouterService,
    private boxInfoTruckService: BoxInfoTruckService,
    public mainHeaderTruckService: MainHeaderTruckService,
    private controlStatusService: ControlStatusService,
    private graphicService: GraphicService,
    private util: Util,
    private controlStatus: ControlStatusService
  ) 
  {
  }

  ngOnInit() 
  {
    this.carregarRoteiroMapa();

  }

  voltarTelaInicial() 
  {
    this.controlStatus.carregando = false;
    this.controlStatusService.currentState = State.visaoGeral;
  }

  onChangeObj(option) 
  {
    this.boxListTruckService.roteiroSelecionado = Number(option);
    this.boxInfoAlertService.getInfoAlertRouter();
    this.boxListTruckService.getListRouterTruckPorId(false);
    this.boxInfoRouterService.getInfoRouter();
    this.boxInfoTruckService.getInfoTruck();
  }

  async carregarRoteiroMapa()
  {
    this.controlStatusService.carregando = true;

    let dados = this.roteiro;

    if(dados != undefined || dados != null)
    {
      await this.graphicService.limparPontosMapa();
      this.graphicService.distanciaTotalPlanejada = dados.Distancia;

      let resposta = await this.boxListTruckService.getListRouterTruckPorId(false);

      let e;
      let eAux;
      if(resposta[0].ResultRotaBinConvert && resposta[0].ResultadoRota == '{}'){     
        let resultadosRotas = resposta[0].ResultRotaBinConvert.split(',')
        e = eval(JSON.parse(Util.decompress(resultadosRotas[0])));
        if(resultadosRotas.length > 1){
          eAux = eval(JSON.parse(Util.decompress(resultadosRotas[1]))); 
        }
      }
      else{
        e =  eval(JSON.parse(resposta[0].ResultadoRota));
        eAux = eval(JSON.parse(resposta[0].ResultadoRotaAux))
      }     

      this.dataUltimaInformacao = isNullOrUndefined(resposta[0].dataUltimaInformacao) ? null : this.util.converteData(resposta[0].dataUltimaInformacao);     
      let contemPontoFixo = eAux? true: false
      if(contemPontoFixo){
        await this.graphicService.visualizarRoteiroMapaAux(eAux);
      }
      await this.graphicService.visualizarRoteiroMapa(e, contemPontoFixo , resposta[0].InfoRota );

      //Ordena visualização pontos no pontos
      this.graphicService.atualizaMapView();
    }
  }

  MostrarOpcoesMenu(opt) {
    switch (opt) {
      case "mostrarMapas": this.controlStatusService.mostrarMapas = true; break;
      case "mostrarLegendas": this.controlStatusService.mostrarLegendas = true; break;
    }
    this.hide(null);
  }

  //Inicio - Dropdown controller
  abreDropdown(){
    this.canSeeConfig = !this.canSeeConfig;
  }

  hide(e: any) {
    this.canSeeConfig = false;
  }
  //Fim - Dropdown controller
}